<template>
  <v-card
    class="user-info-result"
    :disabled="!clickable"
    :class="{ 'selected': selected, 'clickable': clickable }"
    @click="$emit('click')"
  >
    <v-card-text class="client-card">
      <div class="user-info-result__title">
        {{result.name}}
      </div>
      <div class="user-info-result__subtitle">
        {{result.address}}, {{result.post_code}} {{result.city}}
      </div>
      <div class="user-info-result__subtitle">
        Davčna št.: {{result.tax_number}}&nbsp;&nbsp;&nbsp;&nbsp;Zavezanec za DDV: {{result.tax_bound ? 'DA' : 'NE'}}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    result: {
      required: true,
      type: Object
    },
    selected: {
      default: false,
      type: Boolean
    },
    clickable: {
      default: true,
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card--disabled > .client-card {
  opacity: 1;
}
</style>

<style lang="scss" scoped>

.user-info-result {
  width: 100%;
  margin-top: 10px;
  font-size: 22px;
  border-radius: 5px;
  color: black;
  border: 5px solid white;

  &.clickable:hover {
    cursor: pointer;
  }
  &.selected {
    border: 5px solid rgba(0,0,0, 0.25);
  }
  &__title {
    font-weight: bold;
  }
}
</style>
